var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 15.087v2.305l2.412-1.508.682.07c.296.03.598.046.906.046 4.223 0 7-2.788 7-5.5S16.223 5 12 5s-7 2.788-7 5.5c0 1.485.77 2.924 2.196 3.987l.804.6Zm-.47 4.957A1 1 0 0 1 6 19.196V16.09c-1.841-1.373-3-3.369-3-5.59C3 6.358 7.03 3 12 3s9 3.358 9 7.5c0 4.142-4.03 7.5-9 7.5-.376 0-.746-.02-1.11-.056l-3.36 2.1Z",
    clipRule: "evenodd"
  })));
};
export default SvgChat;